import { render, staticRenderFns } from "./exchange-rate-afir.pug?vue&type=template&id=3ba3fa4a&scoped=true&lang=pug&external"
import script from "./exchange-rate-afir.js?vue&type=script&lang=js&external"
export * from "./exchange-rate-afir.js?vue&type=script&lang=js&external"
import style0 from "./exchange-rate-afir.scss?vue&type=style&index=0&id=3ba3fa4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3fa4a",
  null
  
)

export default component.exports